import React from 'react';
import {Button} from 'reactstrap';
import IntlMessages from 'util/IntlMessages';

const Footer = () => {
        return (
            <footer className="app-footer">
                <div className="d-flex flex-row justify-content-between">
                    <div>
                        <span><IntlMessages id="general.company.name"/> &copy;</span>

                    </div>
                    <div>
                        <Button
                            color="link"
                            // href="https://firebase.google.com/docs/firestore"
                            href="http://clientplussolutions.com.au"
                            target="_blank"
                            size="sm"
                            className="text-uppercase">CPS</Button>
                    </div>
                </div>
            </footer>
        );
    }
;

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js